import Styles from "../editScreenStyles.module.css";
import { states } from "../../../../constants/data";
import { yesNo } from "../../../../constants/options";

function DriverEdit({
  fields,
  utilities,
  updateClicked,
  cancelClicked,
}) {
  const {
    createEditScreenInput,
    createNoLabelInput,
    createToggleInput,
    createCustomLabelSelect
  } = utilities;

  return (
    <div className={Styles.modalContainer}>
      <div className={Styles.title}>The Driver</div>
      <div className={Styles.column}>
        <div className={Styles.row}>
          <p className={Styles.label}>Who was driving?</p>
        </div>
        <div className={Styles.groupedInputs}>
          <div className={Styles.spaceholder} style={{ display: "flex", flex: 1 }}>
            {createNoLabelInput(fields.driverFirstName, "100%", Styles.input)}
          </div>
          <div style={{display: "flex", flex:1}}>
            {createNoLabelInput(fields.driverLastName, "100%", Styles.input)}
          </div>
        </div>
        <div className={Styles.row}>
          {createToggleInput(fields.whoIsTheInsured, "100%", yesNo, true)}
          {createToggleInput(fields.driverIsInjured, "100%", yesNo, true)}
        </div>
        {!fields.whoIsTheInsured.value && (
          <>
            <p className={Styles.title}>
              <b>Non-Insured Information</b>
            </p>
            <div className={Styles.row}>
              {createEditScreenInput(fields.whoAddress, "50%", Styles.input, Styles.label)}
              {createEditScreenInput(fields.whoCity, "50%", Styles.input, Styles.label)}
            </div>
            <div className={Styles.row}>
              {createEditScreenInput(fields.whoZipcode, "50%", Styles.input, Styles.label)}
              {createCustomLabelSelect(
                fields.whoState,
                states,
                Styles.select,
                Styles.label,
                { placeholder: "Select a State"}
                )}
            </div>
            <div className={Styles.row} style={{ width: "50%" }}>
              {createEditScreenInput(fields.whoCounty, "100%", Styles.input, Styles.label)}
            </div>
          </>
        )}
        <div className={Styles.buttons}>
          <button
            type="button"
            className={Styles.button}
            onClick={cancelClicked}
          >
            Cancel
          </button>
          <button
            type="button"
            className={Styles.button}
            onClick={updateClicked}
          >
            Update
          </button>
        </div>
      </div>
    </div>
  );
}

export default DriverEdit;
